var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChatCollapsed = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 1.333
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.666 3.668h10.667M2.666 8h10.667M2.666 12.332h10.667M4.552 9.885 2.666 7.999l1.886-1.886"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChatCollapsed);
export default ForwardRef;